import FeatureGates from "@atlaskit/feature-gate-js-client";

import { experiments, useExperiment } from "@/utils/experiment";

const VALID_PRODUCT_KEYS = ["jiraSoftware", "jiraServiceDesk", "confluence"];

export function useDirectBuyCohort(productKey: string) {
    const isGateEnabled = FeatureGates.checkGate(
        "pricing_direct_buy_checkout_fg"
    );

    const validProductKey = VALID_PRODUCT_KEYS.includes(productKey);

    const experiment = useExperiment({
        ...experiments.pricingDirectBuyCheckout,
        options: {
            fireExperimentExposure: false,
            typeGuard: experiments.pricingDirectBuyCheckout.options.typeGuard
        }
    });

    if (!isGateEnabled || !validProductKey) {
        return {
            isVariation: false
        };
    }

    const cohort = experiment.type === "enrolled" ? experiment.value : null;
    const isVariation = cohort === "variation";

    return {
        isVariation
    };
}
